import React from 'react'
import ClientView from './ClientView'
import useFaceProfile from '../utils/useFaceProfile'
import DOMPurify from 'dompurify'
import { useAdvisorInfo } from '../../retirement-income-guide/utils/utils'

const Advisor = props => {
  const { advisorData: data1 } = useFaceProfile()
  const { advisorData: data2 } = useAdvisorInfo()

  const advisorData = data1 || data2

  if (!advisorData) return null

  return (
    <div
      className='Advisor Advisor--color u-bgSizeCover'
      style={{
        backgroundImage: `url(${props.content?.image ?? ''})`,
      }}>
      <div className='u-sizeConstrained u-paddingVert6gu'>
        <div className='Card'>
          <ClientView data={advisorData} labels={props.content} />
        </div>
        <div
          className='AdvisorClient-disclosure AdvisorClient-disclosure--nextGen2024 Content--reversed u-textSizeMsrm2 u-marginTop2gu'
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content.body) }}
        />
      </div>
    </div>
  )
}

export default Advisor
